import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Result, Button } from "antd";

export default function OAuthError() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const error = searchParams.get("error") || "An unknown error occurred";

  useEffect(() => {
    // Auto-redirect after 5 seconds
    const timer = setTimeout(() => {
      navigate("/sign-in");
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full">
        <Result
          status="error"
          title="Authentication Failed"
          subTitle={error}
          extra={[
            <Button
              key="retry"
              type="primary"
              onClick={() => navigate("/sign-in")}
              className="bg-blue-600"
            >
              Back to Login
            </Button>,
            <Button key="home" onClick={() => navigate("/")}>
              Go Home
            </Button>,
          ]}
        />
      </div>
    </div>
  );
}
